import _ from 'underscore';
import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import { InlineChartWrapper } from './inline-chart-wrapper';

export class InlineChartView extends Backbone.View {
  constructor(options) {
    super(options);

    this.filter = options.filter;
    this.isShowChart = true;
    this.options = _.omit(options, 'filter', 'isShowChart', 'resizeChartListener');
  }

  toggleView() {
    this.isShowChart = !this.isShowChart;
    this.render();
  }

  filterUpdated = (filter) => {
    this.filter = filter;
    this.render();
  };

  resizeChartListener = (handler) => {
    this.resizeListener = handler;
  };

  resizeChart = (width) => {
    if (this.resizeListener && width) {
      // Invoke the resize chart listener
      this.resizeListener(width);
    }
  };

  render() {
    ReactDOM.render(<InlineChartWrapper
      filter={this.filter}
      isShowChart={this.isShowChart}
      resizeChartListener={this.resizeChartListener}
      {...this.options}
    />, this.el);
    return this;
  }

  remove() {
    if (this.resizeListener) {
      // Invoke the resize chart listener
      this.resizeListener = null;
    }
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
